import Login from 'components/organisms/Login';

function LoginPage() {
  return <Login />;
}

export default LoginPage;
